<div class="page-container">

    <app-documents-breadcrumbs [showEdit]="false" basePath="Configurazione"></app-documents-breadcrumbs>

    <div class="d-flex flex-row mb-4 align-items-end box-filter">
        <div class="card" style="width: calc(100% - 200px);">
            <div class="card-body">
                <h5 class="card-title">{{'generic.filters.label'|translate}}
                    <button class="mb-2 btn btn-primary btn-sm btn-action-icon ml-0 btn-clear-filter"
                        [ngbTooltip]="'generic.filters.clear'|translate" type="button" (click)="emptyFilters()">
                        <pwc-icon name="clear"></pwc-icon>
                    </button>
                </h5>

                <div class="d-lg-flex flex-lg-row flex-sm-column flex-wrap">
                    <div class="item form-group-sm form-inline">
                        <label for="configuration-filter-name">{{'generic.field.name'|translate}}</label>
                        <input class="form-control input-with-border input-auto-height" id="configuration-filter-name"
                            name="configuration-filter-name" type="text" [(ngModel)]="searchTerm"
                            (ngModelChange)="onSearch()">
                    </div>
                    <div class="item form-group-sm form-inline">
                        <label for="configuration-filter-year">{{'generic.field.years'|translate}}</label>
                        <ng-select bindLabel="code" [placeholder]="'generic.field.years'|translate" appendTo="body"
                            id="configuration-filter-year" style="min-width: 200px; max-width: 250px;"
                            [clearable]="true" [(ngModel)]="searchTermYear" (ngModelChange)="onSearch()">
                            <ng-option [value]="year.id" *ngFor="let year of yearsList">
                                {{year.year}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="item form-group-sm form-inline">
                        <label for="configuration-filter-alias">{{'generic.field.alias'|translate}}</label>
                        <input class="form-control input-with-border input-auto-height" id="configuration-filter-alias"
                            name="configuration-filter-alias" type="text" [(ngModel)]="searchTermAlias"
                            (ngModelChange)="onSearch()">
                    </div>
                </div>
            </div>
        </div>

        <div class="ml-auto">
            <button class="btn btn-ghost ml-auto align-self-end text-nowrap" style="min-width: 175px"
                (click)="openCrateElement()">
                <pwc-icon name="add" style="margin-right:5px;"></pwc-icon>
                <!-- <img src="/assets/images/icons/documents/create_tag.svg" [alt]="'documents.law.bucket.create'|translate" class="btn-ghost-icon"> -->
                <span class="d-inline-block">{{'documents.law.configuration.create'|translate}}</span>
            </button>
        </div>
    </div>

    <div class="card" *ngIf="data && viewChecked">
        <div class="card-body card-table">
            <data-table #dataTable [dataSource]="data" [columns]="columns" [customColumnDefs]="customColumns"
                [customColumns]="customColumnsActive" [enableSelect]="false" (sort)="onSort($event)">

                <ng-container cdkColumnDef="bucket">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'documents.law.bucket.create'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{row.bucket.description}}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="years">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.years'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{getYears(row)}}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="frequency">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.frequency'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{getFrequency(row)}}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="alias">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.alias'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{row.alias}}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="creation_date">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.creation-date'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{row.createdDate|date:'dd/MM/yyyy'}}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="last_execution">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.lastExecution'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{ row.lastExecution|date:'dd/MM/yyyy HH:mm' }}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="next_execution">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.nextExecution'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{ getNextExecution(row) |date:'dd/MM/yyyy' }}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="status">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col">{{'generic.field.status'|translate}}</th>
                    <td cdk-cell *cdkCellDef="let row">
                        {{ convertStatus(row.taskStatus) }}
                    </td>
                </ng-container>
                <ng-container cdkColumnDef="details">
                    <th cdk-header-cell *cdkHeaderCellDef scope="col" style="width: 120px;">
                        {{'generic.action.label'|translate}}
                    </th>
                    <td cdk-cell *cdkCellDef="let row" class="text-right">
                        <pwc-icon name="view" [ngbTooltip]="'generic.action.show-item'|translate" placement="left"
                            *ngIf="enableChanges(row)" class="document-info-icon" (click)="openEditElement(row, true)">
                        </pwc-icon>
                        <pwc-icon name="pen" [ngbTooltip]="'generic.action.edit-item'|translate" placement="left"
                            *ngIf="enableChanges(row) && !isInProgressStatus(row)" class="document-info-icon" (click)="openEditElement(row, false)">
                        </pwc-icon>
                        <pwc-icon id="disabled-icon" name="pen" [ngbTooltip]="'generic.action.cant-edit-item'|translate" placement="left"
                            *ngIf="enableChanges(row) && isInProgressStatus(row)" class="document-info-icon">
                        </pwc-icon>
                        <pwc-icon name="delete" [ngbTooltip]="'generic.action.delete.label'|translate" placement="left"
                            *ngIf="enableChanges(row) && enableDelete(row) && !isInProgressStatus(row)" class="document-info-icon"
                            (click)="openDeleteElement(row)"></pwc-icon>
                        <!-- <pwc-icon name="play" [ngbTooltip]="'generic.action.launch.label'|translate" placement="left" class="document-info-icon" (click)="launchConf(row)"></pwc-icon> -->
                    </td>
                </ng-container>

            </data-table>
        </div>
    </div>

    <div class="my-4">
        <pwc-pagination *ngIf="pagination" [page]="pagination.number + 1" [pageSize]="pagination.size"
            [collectionSize]="pagination.totalElements" (pageChange)="onPageChange($event)"></pwc-pagination>
    </div>

</div>

<pwc-modal #deleteConfigurationModal id="deleteConfigurationModal">
    <div modal-title>{{'documents.law.configuration.delete'|translate}}</div>
    <div modal-body>
        {{'documents.law.configuration.delete-question'|translate}} {{selectedConfiguration.name}}
    </div>
    <div modal-footer class="text-right">
        <button type="button" class="btn btn-undo"
            (click)="deleteConfigurationModal.close()">{{'generic.action.cancel'|translate}}</button>
        <button type="button" class="btn btn-success ml-2"
            (click)="removeElement()">{{'generic.action.confirm'|translate}}</button>
    </div>
</pwc-modal>

<pwc-modal #editConfigurationModal id="editConfigurationModal" class="law-conservation-edit-modal">
    <div modal-title>{{(isPreview() ? ('documents.law.bucket.data'|translate) :
        ('generic.action.edit-item'|translate))}} {{'documents.law.configuration.label'|translate}}
    </div>
    <div modal-body>
        <div class="col-md-12 p-3" *ngIf="isDisabled() && !isPreview()">
            <label class="text-danger">{{'documents.law.configuration.error-message'|translate}}</label>
        </div>
        <div class="form-inline">
            <div class="col-md-12 p-3">
                <div class="row">
                    <div class="col-md-12">{{'generic.field.name'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="text" style="width: 100%"
                            class="form-control form-input no-shadow input-with-border" [disabled]="isPreview()"
                            [(ngModel)]="selectedConfiguration.name">
                        <div *ngIf="!isPreview()" class="invalid-feedback">
                            {{'documents.law.configuration.name-mandatory'|translate}}</div>
                    </div>
                </div>
            </div>

            <ngb-alert [dismissible]="false" type="dark" class="col-md-12 mt-3">
                <strong class="text-danger">1</strong> | {{'documents.law.configuration.system'|translate}}
            </ngb-alert>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.bucket.create'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-bucket'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="false"
                            [disabled]="isDisabled() || isPreview()" [(ngModel)]="selectedConfiguration.bucketId">
                            <ng-option [value]="bucket.id" *ngFor="let bucket of bucketList">
                                {{bucket.bucket + ' - ' + bucket.description}}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="!isPreview() && !isDisabled()" class="invalid-feedback" style="padding-top: 5px;">
                            {{'documents.law.configuration.bucket-required'|translate}}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.send-frequency'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-frequency'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="false" [disabled]="isPreview()"
                            [(ngModel)]="selectedConfiguration.sendingFrequency">
                            <ng-option [value]="frequency.value" *ngFor="let frequency of frequencyList">
                                {{frequency.name}}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="!isPreview()" class="invalid-feedback" style="padding-top: 5px;">
                            {{'documents.law.configuration.frequency-required'|translate}}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'generic.field.fiscal-year'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-year'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="true" [multiple]="true"
                            [disabled]="isDisabled() || isPreview()" [(ngModel)]="selectedFiscalYear">
                            <ng-option [value]="year.id" *ngFor="let year of yearsList">
                                {{year.year}}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="!isPreview() && !isDisabled()" class="invalid-feedback" style="padding-top: 5px;">
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'generic.field.start-date'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="text" class="form-control form-input no-shadow input-with-border"
                            placeholder="DD/MM/YYYY" [disabled]="isDisabled() || isPreview()"
                            (ngModelChange)="setNgbSendingDate($event)" [ngModel]="startDate" container="body"
                            ngbDatepicker #d1="ngbDatepicker" style="width: 100%;">
                        <div (click)="d1.toggle()" *ngIf="!isDisabled() && !isPreview()"
                            class="form-input-icon append pointer w-auto" style="right: 25px;">
                            <pwc-icon name="calendar_small"></pwc-icon>
                        </div>
                        <div *ngIf="!isPreview() && !isDisabled()" class="invalid-feedback">
                            {{'documents.law.configuration.start-date-required'|translate}}</div>
                    </div>
                </div>
            </div>

            <ngb-alert [dismissible]="false" type="dark" class="col-md-12 mt-3">
                <strong class="text-danger">2</strong> |
                {{'documents.law.configuration.system-and-signature-caps'|translate}}
            </ngb-alert>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.signature-system'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-signature'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="false"
                            [disabled]="isDisabled() || isPreview()"
                            [(ngModel)]="selectedConfiguration.preservationSystem">
                            <ng-option [value]="optionINFOCERT()">{{optionINFOCERT()}}</ng-option>
                        </ng-select>
                        <div *ngIf="!isPreview() && !isDisabled()" class="invalid-feedback" style="padding-top: 5px;">
                            {{'documents.law.configuration.signature-required'|translate}}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.alias-signature'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="text" style="width: 100%"
                            class="form-control form-input no-shadow input-with-border"
                            [(ngModel)]="selectedConfiguration.alias" [disabled]="isPreview()">
                        <div *ngIf="!isPreview()" class="invalid-feedback">
                            {{'documents.law.configuration.alias-signature-required'|translate}}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.pin-signature'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="password" style="width: 100%"
                            class="form-control form-input no-shadow input-with-border" [disabled]="isPreview()"
                            [(ngModel)]="selectedConfiguration.pin" autocomplete="off">
                        <div *ngIf="!isPreview()" class="invalid-feedback">
                            {{'documents.law.configuration.pin-signature-required'|translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div modal-footer class="text-right" *ngIf="!isPreview()">
        <button type="button" class="btn btn-undo"
            (click)="editConfigurationModal.close()">{{'generic.action.cancel'|translate}}</button>
        <button type="button" class="btn btn-success ml-2"
            (click)="editElement()">{{'generic.action.confirm'|translate}}</button>
    </div>
</pwc-modal>

<pwc-modal #createConfiguration id="createConfiguration" class="law-conservation-edit-modal">
    <div modal-title>{{'documents.law.configuration.create'|translate}}</div>
    <div modal-body>
        <div class="form-inline">
            <div class="col-md-12 p-3">
                <div class="row">
                    <div class="col-md-12">{{'generic.field.name'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="text" style="width: 100%"
                            class="form-control form-input no-shadow input-with-border"
                            [(ngModel)]="newConfiguration.name">
                        <div class="invalid-feedback">
                            {{'documents.law.configuration.name-mandatory'|translate}}</div>
                    </div>
                </div>
            </div>

            <ngb-alert [dismissible]="false" type="dark" class="col-md-12 mt-3">
                <strong class="text-danger">1</strong> | {{'documents.law.configuration.system'|translate}}
            </ngb-alert>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.bucket.create'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-bucket'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="false"
                            [(ngModel)]="newConfiguration.bucketId">
                            <ng-option [value]="bucket.id" *ngFor="let bucket of bucketList">
                                {{bucket.bucket + ' - ' + bucket.description}}
                            </ng-option>
                        </ng-select>
                        <div class="invalid-feedback" style="padding-top: 5px;">
                            {{'documents.law.configuration.bucket-required'|translate}}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.send-frequency'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-frequency'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="false"
                            [(ngModel)]="newConfiguration.sendingFrequency">
                            <ng-option [value]="frequency.value" *ngFor="let frequency of frequencyList">
                                {{frequency.name}}
                            </ng-option>
                        </ng-select>
                        <div class="invalid-feedback" style="padding-top: 5px;">
                            {{'documents.law.configuration.frequency-required'|translate}}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'generic.field.fiscal-year'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-year'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="true" [multiple]="true"
                            [(ngModel)]="selectedFiscalYear">
                            <ng-option [value]="year.id" *ngFor="let year of yearsList">
                                {{year.year}}
                            </ng-option>
                        </ng-select>
                        <div class="invalid-feedback" style="padding-top: 5px;"></div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'generic.field.start-date'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="text" class="form-control form-input no-shadow input-with-border"
                            placeholder="DD/MM/YYYY" (ngModelChange)="setNgbSendingDate($event)" [ngModel]="startDate"
                            container="body" ngbDatepicker #d2="ngbDatepicker" style="width: 100%;">
                        <div (click)="d2.toggle()" class="form-input-icon append pointer w-auto" style="right: 25px;">
                            <pwc-icon name="calendar_small"></pwc-icon>
                        </div>
                        <div class="invalid-feedback">
                            {{'documents.law.configuration.start-date-required'|translate}}</div>
                    </div>
                </div>
            </div>

            <ngb-alert [dismissible]="false" type="dark" class="col-md-12 mt-3">
                <strong class="text-danger">2</strong> |
                {{'documents.law.configuration.system-and-signature'|translate}}
            </ngb-alert>

            <div class="col-md-6 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.system-and-signature'|translate}}</div>
                    <div class="orm-group form-input-group col-md-12">
                        <ng-select bindLabel="code" [placeholder]="'generic.placeholder.select-signature'|translate"
                            appendTo="body" style="width: 100%;" class="" [clearable]="false"
                            [(ngModel)]="newConfiguration.preservationSystem">
                            <ng-option [value]="optionINFOCERT()">{{optionINFOCERT()}}</ng-option>
                        </ng-select>
                        <div class="invalid-feedback" style="padding-top: 5px;">
                            {{'documents.law.configuration.signature-required'|translate}}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.alias-signature'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="text" style="width: 100%"
                            class="form-control form-input no-shadow input-with-border"
                            [(ngModel)]="newConfiguration.alias">
                        <div class="invalid-feedback">
                            {{'documents.law.configuration.alias-signature-required'|translate}}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 p-3">
                <div class="row">
                    <div class="col-md-12">{{'documents.law.configuration.pin-signature'|translate}}</div>
                    <div class="form-group form-input-group col-md-12">
                        <input type="password" style="width: 100%"
                            class="form-control form-input no-shadow input-with-border"
                            [(ngModel)]="newConfiguration.pin" autocomplete="off">
                        <div class="invalid-feedback">
                            {{'documents.law.configuration.pin-signature-required'|translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div modal-footer class="text-right">
        <button type="button" class="btn btn-undo"
            (click)="createConfiguration.close()">{{'generic.action.cancel'|translate}}</button>
        <button type="button" class="btn btn-success ml-2"
            (click)="addElement()">{{'generic.action.confirm'|translate}}</button>
    </div>
</pwc-modal>